import { PropertyData, SubjectData } from '@aloft/toolkit-shared';
import { createAction } from '@reduxjs/toolkit';

export type LoadSubjectPayload = {
  id: 'subject';
} & SubjectData;

export type LoadCompPayload = {
  id: string;
} & PropertyData;

export type LoadPropertyPayload = LoadSubjectPayload | LoadCompPayload;

type LoadPropertiesPayload = {
  properties: LoadPropertyPayload[];
  compSequence: string[];
  rentalCompSequence: string[];
};

export const loadProperties = createAction<LoadPropertiesPayload>('loadProperties');
